<div class="tableFixHead">
  <table class="table" [ngClass]="headers.tableClasses">
    <thead>
      <tr>
        <th *ngIf="headers.selectable">
          <input
            type="checkbox"
            (change)="handleSelectAll($event)"
            [indeterminate]="selected.length > 0 && selected.length !== totalItems"
            [checked]="selected.length > 0" />
        </th>
        <ng-container *ngFor="let column of headers.columns">
          <th scope="col" *ngIf="isViewable(column)" [ngClass]="column.headerClasses" [style]="column.headerStyles">
            <a
              *ngIf="column.sortable; else nonSortable"
              href="javascript:;"
              (click)="triggerAction('sort', column.name)">
              {{ column.label }}
              <i
                [ngClass]="{
                  fas: true,
                  'fa-sort-up': sort.name === column.name && sort.direction === 'asc',
                  'fa-sort-down': sort.name === column.name && sort.direction === 'desc',
                  sorted: sort.name === column.name
                }"></i>
            </a>
            <ng-template #nonSortable>
              <span>
                {{ column.label }}
              </span>
            </ng-template>
          </th>
        </ng-container>
        <th *ngIf="headers?.statusToggle">
          <a href="javascript:;" (click)="triggerAction('sort', 'enabled')">
            Status
            <i
              [ngClass]="{
                fas: true,
                'fa-sort-up': sort.field === 'enabled' && sort.direction === 'asc',
                'fa-sort-down': sort.field === 'enabled' && sort.direction === 'desc',
                sorted: sort.field === 'enabled'
              }"></i>
          </a>
        </th>
        <th *ngIf="headers?.rowActions.length" class="text-right"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of rows">
        <tr
          #rowRef
          (click)="headers.click && headers.click($event, row, rowRef, snapshotRef)"
          [ngClass]="{ clickable: headers.click }">
          <td *ngIf="headers.selectable">
            <input
              type="checkbox"
              [value]="row.id"
              [checked]="selected?.includes(row)"
              (change)="handleCheckbox($event, row)" />
          </td>
          <ng-container *ngFor="let column of headers.columns">
            <td *ngIf="isViewable(column)" [ngClass]="column.columnClasses" [style]="column.columnStyles">
              <span *ngIf="column.popover && column.popover(row); else contentColumn" class="alert-code">
                <span class="alert-code-icon"><span>i</span></span>
                <span class="alert-code-content">{{ printRowData(column.property, row, column.defaultValue) }}</span>
              </span>
              <ng-template #contentColumn>
                <a
                  *ngIf="column.show && column.show(row, meta) && column.link && !column.selectable; else dataColumn"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="{{ column?.tooltip ? column.tooltip(row) : printRowData(column.property, row) }}"
                  class="link"
                  [routerLink]="column?.link(row) ? column.link(row, meta) : []"
                  [ngClass]="column.dataClasses && column.dataClasses(row)"
                  [style]="column.dataStyles">
                  {{ printRowData(column.property, row, column.defaultValue) }}
                </a>
                <input
                  [ngStyle]="{ cursor: column.checkboxDisabled ? 'not-allowed' : 'pointer' }"
                  *ngIf="column.selectable"
                  (click)="(column.checkboxDisabled ? false : true)"
                  type="checkbox"
                  [value]="row.id"
                  [checked]="printRowData(column.property, row, column.defaultValue)"
                  (change)="handleJobBoardCheckbox($event)" />
                <ng-template #dataColumn>
                  <span
                    data-toggle="tooltip"
                    data-placement="top"
                    title="{{ column?.tooltip ? column.tooltip(row) : printRowData(column.property, row) }}"
                    *ngIf="!column.component && !column.selectable"
                    (click)="column.click && column.show(row, meta) && column.click($event, row)"
                    [ngClass]="column.dataClasses && column.dataClasses(row)"
                    [style]="column.dataStyles">
                    {{ printRowData(column.property, row) }}
                  </span>
                  <app-employee-status
                    *ngIf="column.component == 'employee-status'"
                    [status]="printRowData(column.property, row)">
                  </app-employee-status>
                  <app-hub-status
                    *ngIf="column.component == 'hub-status'"
                    [status]="printRowData(column.property, row)">
                  </app-hub-status>
                  <app-manage-jobs-status
                    *ngIf="column.component == 'manage-jobs-status'"
                    [getData]="getData"
                    [job]="row"
                    [status]="printRowData(column.property, row)">
                  </app-manage-jobs-status>
                  <app-employee-profile
                    *ngIf="column.component == 'employee-profile'"
                    [employee]="row"
                    [imageSrc]="row?.avatar?.url">
                  </app-employee-profile>
                  <app-job-count
                    *ngIf="column.component == 'job-count'"
                    [jobCount]="printRowData(column.property, row)">
                  </app-job-count>
                  <app-add-employee-button *ngIf="column.component == 'add-employee-button'"></app-add-employee-button>
                </ng-template>
              </ng-template>
            </td>
          </ng-container>

          <td *ngIf="headers?.statusToggle">
            <app-toggle [enabled]="row.enabled" [allowChanges]="true" (action)="triggerAction($event, row)">
            </app-toggle>
          </td>
          <td *ngIf="headers?.rowActions.length" class="text-right justify-content-end flex-nowrap">
            <span *ngFor="let action of headers.rowActions">
              <app-job-pointe-action-button
                [row]="row"
                *ngIf="action.show(row, meta)"
                [action]="action"
                (submitAction)="triggerAction($event, row, action.payload)"
                (click)="action.click && action.click($event, row)">
              </app-job-pointe-action-button>
            </span>
          </td>
        </tr>
        <tr class="collapse" #snapshotRef>
          <td colspan="100%">
            <app-tool-snapshot [row]="row"></app-tool-snapshot>
          </td>
        </tr>
      </ng-container>
      <tr *ngIf="rows?.length === 0">
        <td [attr.colspan]="headers.columns.length + 2" class="no-results">
          {{
            headers.noResultsMessage
              ? headers.noResultsMessage
              : source === 'employees'
                ? 'Enter Search Criteria'
                : 'No results found.'
          }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
